import { base_url } from "Backend/api";

/** يبني رابط صورة التخزين كما فى تفاصيل المطعم/الماركت */
export function resolveMediaUrl(raw) {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim();
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  const path = s.replace(/^\/+/, "");
  if (path.startsWith("storage/")) {
    return `${base_url}/${path}`;
  }
  return `${base_url}/storage/app/public/${path}`;
}

/** صورة أول متجر فى الطلب (مطعم أو ماركت) لعرضها فى قائمة الطلبات */
export function getOrderStoreImage(order) {
  const items = order?.items || [];
  for (const item of items) {
    if (item.dish?.restaurant) {
      const r = item.dish.restaurant;
      const raw =
        r.media?.main_image ||
        r.media?.logo ||
        r.main_image ||
        r.logo ||
        r.image ||
        r.cover_image;
      const url = resolveMediaUrl(raw);
      if (url) return url;
    }
    if (item.product?.market) {
      const m = item.product.market;
      const raw =
        m.media?.main_image ||
        m.media?.logo ||
        m.main_image ||
        m.logo ||
        m.image ||
        m.cover_image;
      const url = resolveMediaUrl(raw);
      if (url) return url;
    }
  }
  const r = order?.restaurant;
  if (r) {
    const raw =
      r.media?.main_image ||
      r.media?.logo ||
      r.main_image ||
      r.logo ||
      r.image;
    const url = resolveMediaUrl(raw);
    if (url) return url;
  }
  const m = order?.market;
  if (m) {
    const raw =
      m.media?.main_image ||
      m.media?.logo ||
      m.main_image ||
      m.logo ||
      m.image;
    const url = resolveMediaUrl(raw);
    if (url) return url;
  }
  return null;
}
